<div
  [attr.data-color]="'black-white'"
  class="rect"
  (click)="drawerOpen = true"
>
  @if (alarmEvent) {
    <motn-tile-alarm-badge
      (click)="drawerOpen = true"
      [alarmEvent]="alarmEvent"
    ></motn-tile-alarm-badge>
  }
  <div
    class="name"
  >
    @if (displayIcon) {
      <div>
        <div
          (click)="openTileMenu(); $event.stopPropagation()"
          [innerHtml]="'<i class=\'fa-regular fa-'+displayIcon+'\'>'"
          class="icon header-icon"
        ></div>

        @if (tileMenuOpen) {
          <motn-popover-menu
            (clickedOption$)="tileMenuOpen = false"
            (clickedOutsideMenu$)="tileMenuOpen = false"
            [menuTitle]="tileMenuTitle"
            [optionGroup]="displayedMenuOptions"
            [overlayPositions]="popoverPositions"
          ></motn-popover-menu>
        }
      </div>
    }

    {{ tile.displayName }}

    @if (facetValues.length > 0) {
      <div class="facets">
        @for (val of facetValues; track $index) {
          @if (!$first) {<i class="fa-solid fa-circle-dot"></i>}
          <span>{{ val }}</span>
        }
      </div>
    }
  </div>
  @if (tile) {
    <div
      class="value tiles-box"
      [class.loading]="isLoading"
    >
      @if (isLoading) {
        <div
          class="loading-container"
          [ngStyle]="{
          'min-height': isDataPointsView ? dataPointsViewMinHeight : 'auto'
        }"
        >
          <motn-spinner></motn-spinner>
        </div>
      } @else {
        @if (matchingChildTiles && matchingChildTiles.length > 0) {
          @if (isDataPointsView && isScrollPresent) {
            <div
              (click)="scrollTileUp(); $event.stopPropagation()"
              [innerHtml]="'<i class=\'fa-regular fa-chevron-up\'>'"
              class="icon scroll-up-button"
            ></div>
          }
          @if (isDefaultView) {
            <div
              class="minimal-child-tiles"
            >
              @for (childTile of matchingChildTiles; track childTile.ID) {
                <motn-tile-minimal
                  [elemDef]="getTileDef(childTile)"
                  [rawTile]="childTile"
                  class="child-tile"
                >
                </motn-tile-minimal>
              }
            </div>
          }
          @if (isPopoverTile) {
            <motn-popover-tile
              (click)="$event.stopPropagation();"
              (clickedOutside$)="isPopoverTile = false"
              [rawTile]="popoverRawTile"
              [style.top.px]="popoverTilePositionHeight"
            >
            </motn-popover-tile>
          }
          @if (isDataPointsView) {
            <div
              #dataPointsScrollableBox
              [ngStyle]="{
              'max-height.px': dataPointsFolderHeight,
              'min-height': dataPointsViewMinHeight
            }"
              (mouseenter)="updateScrollPresence()"
              class="data-points-child-tiles"
            >
              @for (childTile of dataPointTiles; track childTile.ID) {
                <motn-tile-data-point
                  (togglePopoverTile)="onTogglePopoverTile($event)"
                  [elemDef]="getTileDef(childTile)"
                  [rawTile]="childTile"
                  class="child-tile"
                >
                </motn-tile-data-point>
              }
            </div>
          }
          @if (isDataPointsView && isScrollPresent) {
            <div
              (click)="scrollTileDown(); $event.stopPropagation()"
              [innerHtml]="'<i class=\'fa-regular fa-chevron-down\'>'"
              class="icon scroll-down-button"
            ></div>
          }
        }
      }
    </div>
  }
</div>

@if (drawerOpen) {
  <motn-tile-folder-drawer
    (clickedOutside)="closeDrawer()"
    [childTiles]="childTiles"
    [displayIcon]="displayIcon"
    [displayName]="tile.displayName"
  ></motn-tile-folder-drawer>
}

@if (editingTile) {
  <motn-tile-editor
    [tileId]="tile.ID"
    (closed$)="editingTile = false"
    (deleted$)="editingTile = false"
    (saved$)="refreshChildren()"
  ></motn-tile-editor>
}
